import { render } from "./CourseDetails.vue?vue&type=template&id=15477f8a&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"

import "./CourseDetails.vue?vue&type=style&index=0&id=15477f8a&scoped=true&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15477f8a"]])

export default __exports__